module.exports = __webpack_public_path__ + "static/media/12Demo Photo-ink-min.baaa1b48.jpeg";